import { Typography } from "@mui/material";
import React from "react";
import { useLocalization } from "../../../../hooks/useLocalization";

export const CountryUsageOtherTooltipContent: React.FC = () => {
  const { t } = useLocalization();

  return (
    <Typography sx={{ fontSize: 12, fontWeight: 500, lineHeight: "16px" }}>
      {t("pages.dataAnalytics.internalUsage.countryUsage.otherTooltip")}
    </Typography>
  );
};
